import { DateTime } from 'luxon';
import React, { useEffect, useRef, useState } from 'react';
import { DateRangePicker as ReactDateRangePicker } from 'react-date-range';
import { Button, Variant } from '../Button';
import '../style/react-date-range/styles.css'; // main css file
import '../style/react-date-range/theme/default.css'; // theme css file
import { Text, TextType } from '../Text';
import { Side } from '../types';
import { appendClassProps } from '../util';
import { useOutsideAlerter } from '../util/hooks';
/**
 - Use DateRangePicker to select a date range
 */
export const DateRangePicker = ({ side, dateRange, title, className, startPlaceholder, endPlaceholder, minDate: minDateProp, maxDate: maxDateProp, maxDays, onChange }) => {
    const wrapperRef = useRef(null);
    const [minDate, setMinDate] = useState(minDateProp);
    const [maxDate, setMaxDate] = useState(maxDateProp);
    const [from, setFrom] = useState(dateRange?.from);
    const [to, setTo] = useState(dateRange?.to);
    const [showMenu, setShowMenu] = useState(false);
    useEffect(() => {
        setFrom(dateRange?.from);
        setTo(dateRange?.to);
    }, [dateRange]);
    const handleClickWrapper = () => {
        setShowMenu(false);
    };
    useOutsideAlerter(wrapperRef, handleClickWrapper);
    const handleClickDateIcon = () => {
        setShowMenu(true);
    };
    const handleChange = (item) => {
        const start = DateTime.fromJSDate(item.selection.startDate);
        let end = DateTime.fromJSDate(item.selection.endDate);
        if (maxDays) {
            // on first selection
            let min, max;
            if (start.equals(end)) {
                // restrict to maxDays
                min = start.minus({ days: maxDays }).toJSDate();
                max = start.plus({ days: maxDays }).toJSDate();
            }
            else {
                // don't restrict to maxDays
                min = undefined;
                max = undefined;
            }
            if (end.diff(start, 'days').days > maxDays) {
                end = start.plus({ days: maxDays });
            }
            setMinDate(min);
            setMaxDate(max);
        }
        const startDate = start.toJSDate();
        const endDate = end.toJSDate();
        setFrom(startDate);
        setTo(endDate);
        onChange({
            from: startDate,
            to: endDate
        });
    };
    return (React.createElement("div", { className: `relative${appendClassProps(className)}`, "data-testid": "datePicker" },
        title && React.createElement(Text, { type: TextType.h6 }, title),
        React.createElement(Button, { variant: Variant.secondary, onClick: handleClickDateIcon }, `${from
            ? DateTime.fromJSDate(from).toLocaleString(DateTime.DATE_MED)
            : startPlaceholder} - ${to
            ? DateTime.fromJSDate(to).toLocaleString(DateTime.DATE_MED)
            : endPlaceholder}`),
        React.createElement("div", { className: `shadow-md z-10 text-blue-800 flex flex-col gap-2 absolute top-8 ${side === Side.right ? 'right-0' : 'left-0'} rounded-tl-sm rounded-b-sm ${showMenu ? '' : ' hidden'}`, ref: wrapperRef },
            React.createElement(ReactDateRangePicker, { onChange: handleChange, months: 2, ranges: [
                    {
                        startDate: from,
                        endDate: to,
                        key: 'selection'
                    }
                ], direction: "horizontal", minDate: minDate, maxDate: maxDate, showPreview: false, editableDateInputs: true }))));
};
export * from './index.types';
//# sourceMappingURL=index.js.map